<template>
  <aside
    ref="disclaimerRef"
    class="disclaimer-container"
    role="note"
  >
    <details ref="detailsRef" class="risk-warning-details">
      <summary class="risk-warning-toggle">
        <span class="risk-warning-toggle-label">
          {{ t('footer.info', { percentage: lossPercentage }) }}
        </span>
        <span class="risk-warning-toggle-icon" aria-hidden="true"></span>
      </summary>

      <div class="risk-warning-content">
        <p class="risk-warning-text">
          {{ t('footer.disclaimer', { percentage: lossPercentage }) }}
        </p>
      </div>
    </details>
  </aside>
</template>

<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const lossPercentage = import.meta.env.VITE_CFD_LOSS_PERCENTAGE || 'error';
const disclaimerRef = ref<HTMLElement | null>(null);
const detailsRef = ref<HTMLDetailsElement | null>(null);
let resizeObserver: ResizeObserver | undefined;
let desktopMediaQuery: MediaQueryList | undefined;

const updateRiskWarningHeight = () => {
  const height = disclaimerRef.value?.getBoundingClientRect().height || 0;
  document.documentElement.style.setProperty('--risk-warning-height', `${Math.ceil(height)}px`);
};

const handleDesktopBreakpoint = (event: MediaQueryListEvent | MediaQueryList) => {
  if (detailsRef.value) {
    detailsRef.value.open = event.matches;
  }
};

onMounted(async () => {
  desktopMediaQuery = window.matchMedia('(min-width: 769px)');
  handleDesktopBreakpoint(desktopMediaQuery);
  desktopMediaQuery.addEventListener('change', handleDesktopBreakpoint);

  await nextTick();
  updateRiskWarningHeight();

  if ('ResizeObserver' in window && disclaimerRef.value) {
    resizeObserver = new ResizeObserver(updateRiskWarningHeight);
    resizeObserver.observe(disclaimerRef.value);
  }

  window.addEventListener('resize', updateRiskWarningHeight, { passive: true });
});

onBeforeUnmount(() => {
  resizeObserver?.disconnect();
  desktopMediaQuery?.removeEventListener('change', handleDesktopBreakpoint);
  window.removeEventListener('resize', updateRiskWarningHeight);
  document.documentElement.style.removeProperty('--risk-warning-height');
});
</script>
